import { Box, Button, Typography } from '@mui/material';

import { Block } from 'components/page';
import { DreConfigTitle } from 'pages/financeiro/dre/configuracao/components/DreConfigTitle';
import { useDreConfigContext } from 'pages/financeiro/dre/configuracao/contexts/DreConfigContext';

export function DreConfigGrupos() {
    const { grupos, activeGrupo, setActiveGrupo, setActiveSubgrupo, isFetchingGrupos } = useDreConfigContext();

    return (
        <Block
            sx={{
                flex: 2,
                top: 16,
                margin: 0,
                padding: 0,
                minWidth: 180,
                display: 'flex',
                overflow: 'hidden',
                flexDirection: 'column',
                position: {
                    xs: 'static',
                    md: 'sticky',
                },
            }}
        >
            <DreConfigTitle title="Grupos" />

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    padding: 1,
                    minHeight: 78,
                    gap: isFetchingGrupos ? 0.5 : 0,
                }}
            >
                {isFetchingGrupos &&
                    Array.from({ length: 4 }).map((_, index) => (
                        <Box key={index} className="pulse" sx={{ height: 30, backgroundColor: 'grey.200', borderRadius: 1 }} />
                    ))}

                {!isFetchingGrupos && grupos.length === 0 && <Typography sx={{ textAlign: 'center' }}>Nenhum grupo encontrado</Typography>}

                {!isFetchingGrupos &&
                    grupos.map((grupo) => {
                        const isActiveGrupo = activeGrupo?.idDreMercadologicaTipoGrupoExibicao === grupo.idDreMercadologicaTipoGrupoExibicao;

                        return (
                            <Button
                                variant="text"
                                key={grupo.idDreMercadologicaTipoGrupoExibicao}
                                sx={{
                                    height: 30,
                                    paddingX: 1,
                                    paddingY: 0.5,
                                    textTransform: 'none',
                                    fontSize: '14px',
                                    fontWeight: '700',
                                    justifyContent: 'flex-start',
                                    backgroundColor: isActiveGrupo ? 'grey.200' : '',
                                }}
                                onClick={() => {
                                    setActiveGrupo(grupo);
                                    setActiveSubgrupo(null);
                                }}
                            >
                                {grupo.dsDreMercadologicaTipoGrupoExibicao}
                            </Button>
                        );
                    })}
            </Box>
        </Block>
    );
}
